// extracted by css-extract-rspack-plugin
export default {"cls1":"SnackBar-cls1_MTa","cls2":"SnackBar-cls2_DDK SnackBar-cls1_MTa"};